import React from 'react';
import { Check, ExclamationMark } from '@phosphor-icons/react';
import classNames from 'classnames';

import { Spinner } from '../../../../components/general';

import { AnalysisFileStatus } from '../../../../types';

const statusDict: Record<AnalysisFileStatus, string | null> = {
  pending: null,
  converting: 'Converting the file',
  preparing: 'Generating the thumbnail',
  analysing: 'Extracting the clips',
  completed: null,
  failed: 'An error occurred!',
};

interface Props {
  status: AnalysisFileStatus;
}

const ThumbnailStatus: React.FC<Props> = (props) => {
  const { status } = props;

  if (status === 'pending') return null;

  const iconClass =
    'absolute w-full h-full flex items-center justify-center bg-white rounded-full transition-all duration-500';

  return (
    <React.Fragment>
      <div className="absolute w-6 h-6">
        {/* check icon */}
        <div
          className={classNames(
            iconClass,
            'text-success-900',
            status === 'completed' ? 'opacity-100' : 'opacity-0',
          )}
        >
          <Check />
        </div>

        {/* error icon */}
        <div
          className={classNames(
            iconClass,
            'text-error-900',
            status === 'failed' ? 'opacity-100' : 'opacity-0',
          )}
        >
          <ExclamationMark />
        </div>

        {/* spinner */}
        <Spinner
          color="white"
          className={classNames(
            'transition-all duration-500',
            !['completed', 'failed'].includes(status)
              ? 'opacity-100'
              : 'opacity-0',
          )}
        />
      </div>

      {statusDict[status] && (
        <div className="absolute bottom-[10%] text-[0.5rem] text-white hidden sm:block">
          {statusDict[status]}
        </div>
      )}
    </React.Fragment>
  );
};

export default ThumbnailStatus;
